import { Injectable, computed, inject, signal } from '@angular/core';
import {
  DocumentData,
  Firestore,
  QueryDocumentSnapshot,
  addDoc,
  collection,
  collectionSnapshots,
  deleteDoc,
  doc,
  getDoc,
  updateDoc,
} from '@angular/fire/firestore';
import { Router } from '@angular/router';
import { Observable, Subscription, catchError, map, of } from 'rxjs';
import { CustomAssessment } from './model';
import { OfficeService } from './office.service';
import { LogService } from './log.service';

@Injectable({
  providedIn: 'root',
})
export class CustomAssessmentsService {
  officeService = inject(OfficeService);
  firestore: Firestore = inject(Firestore);
  router: Router = inject(Router);
  customAssessmentList = signal<CustomAssessment[]>([]);

  customAssessmentSubscription: Subscription | undefined;

  collectionName = computed(() => {
    return this.officeService.officePath() + '/customAssessments';
  });
  private logger: LogService = inject(LogService);

  getCustomAssessments() {
    if (this.customAssessmentSubscription === undefined) {
      console.log('getCustomAssessments ' + this.collectionName());
      const CustomAssessmentsCollection = collection(this.firestore, this.collectionName());
      const collectionData$: Observable<QueryDocumentSnapshot<DocumentData, DocumentData>[]> =
        collectionSnapshots(CustomAssessmentsCollection);
      this.customAssessmentSubscription = collectionData$
        .pipe(
          map(result => {
            return result.map(snapshot => {
              const CustomAssessment: CustomAssessment = {
                ...(snapshot.data() as CustomAssessment),
                _documentId: snapshot.id,
              };
              return CustomAssessment;
            });
          }),
          catchError((_error: any) => {
            const error = _error.code;
            console.log('error aaa', { error });
            if (error === 'permission-denied') {
              console.log('loggedout???');
            } else {
              this.logger.error('error in getCustomAssessments', { error });
            }
            return of([]);
          })
        )
        .subscribe((result: CustomAssessment[]) => {
          const sortedlist = result.sort((a, b) => a.id! - b.id!);
          this.customAssessmentList.set(sortedlist);
          console.log('[data] CustomAssessments', { sortedlist });
        });
    }
  }

  async getCustomAssessment(documentId: string): Promise<CustomAssessment> {
    const docRef = doc(this.firestore, this.collectionName(), documentId);
    const snapshot = await getDoc(docRef);
    const CustomAssessment: CustomAssessment = { ...(snapshot.data() as CustomAssessment), _documentId: snapshot.id };
    return CustomAssessment;
  }

  createCustomAssessment(CustomAssessment: CustomAssessment) {
    return addDoc(collection(this.firestore, this.collectionName()), CustomAssessment).then(result => {
      console.log('createCustomAssessment result', result);
    });
  }

  updateCustomAssessment(CustomAssessment: CustomAssessment) {
    const { _documentId, ...CustomAssessmentData } = CustomAssessment;
    const docRef = doc(this.firestore, this.collectionName(), _documentId!);
    return updateDoc(docRef, CustomAssessmentData).then(result => {
      console.log('updateCustomAssessment result', result);
    });
  }

  deleteCustomAssessment(CustomAssessment: CustomAssessment) {
    const docRef = doc(this.firestore, this.collectionName(), CustomAssessment._documentId!);
    return deleteDoc(docRef).then(result => {
      console.log('deleteCustomAssessment result', result);
    });
  }
}
